import { getAccessToken, getRefreshToken, updateTokensInLocalStorage, clearUserLocalStorage } from "./../data/localStorage";
import { refreshAccessToken } from "./auth";

let refreshPromise = null;

// clear the session and send the user back to login. We go straight to /login
// (not /logout) because the refresh token is already dead — calling the logout
// API would just 401 again and could bounce back here in a loop.
const throwOut = () => {
	clearUserLocalStorage();
	window.location = "/login";
};

const runRefresh = () => {
	if (refreshPromise) return refreshPromise;
	const refreshToken = getRefreshToken();
	if (!refreshToken) {
		return Promise.reject(new Error("No refresh token available"));
	}
	refreshPromise = refreshAccessToken(refreshToken)
		.then((tokens) => {
			updateTokensInLocalStorage(tokens);
			return tokens.accessToken;
		})
		.finally(() => {
			refreshPromise = null;
		});
	return refreshPromise;
};

const buildRequestOptions = (method, body, accessToken) => {
	const headers = {
		Authorization: accessToken ? `Bearer ${accessToken}` : "",
	};
	if (method === "GET") {
		return { method, headers };
	}
	return {
		method,
		body: JSON.stringify(body),
		headers: { ...headers, "Content-type": "application/json" },
	};
};

export const reqIntercept = async (url, method = "POST", body = null, contentType = "application/json") => {
	try {
		let res = await fetch(url, buildRequestOptions(method, body, getAccessToken()));

		if (res && res.status === 401) {
			try {
				const newAccessToken = await runRefresh();
				res = await fetch(url, buildRequestOptions(method, body, newAccessToken));
			} catch (refreshErr) {
				// refresh token is invalid/expired (401) — throw the user out of the system
				console.error("Token refresh failed", refreshErr);
				throwOut();
				return;
			}
		}

		const json = await res.json();
		return json;
	} catch (err) {
		console.error(err);
		return Promise.reject(new Error(err));
	}
};
